<template>
  <div class="output-container">
    <div class="sorting">
      <div class="form-group">
        <div class="sort-wrapper">
          <span>Sorting</span>
          <select class="form-control custom-select" id="exampleFormControlSelect1" v-model="sortCriteria">
            <option value="title,asc" selected>Title asc</option>
            <option value="title,desc">Title desc</option>
            <option value="event_date_start,asc">Event date asc</option>
            <option value="event_date_start,desc">Event date desc</option>
            <option value="registration_deadline,asc">Registration deadline asc</option>
            <option value="registration_deadline,desc">Registration deadline desc</option>
            <option value="country,asc">Country asc</option>
            <option value="country,desc">Country desc</option>
            <option value="city,asc">City asc</option>
            <option value="city,desc">City desc</option>
          </select>
        </div>
      </div>
    </div>
    <div v-if="this.$store.state.completedLoading" >
      <div v-if="this.$store.state.wholeDatabase.length >= 1 && this.$store.state.fetchError === 0" class="card-deck">
        <div v-for="item in this.$store.state.wholeDatabase" :key="item.uid" :id="item.uid" class="card-div">
          <div class="card"  @click="getModalId(item.uid);">
            <div class="card-body">
              <div class="card-main-content">
                <div class="card-content">
                  <div class="card-title-wrapper">
                    <h5 class="card-title">{{
                        `${this.getNiceDate(item.event_date_start)} - ${this.getNiceDate(item.event_date_end)}`
                      }}</h5>
                  </div>
                </div>
              </div>
              <p class="card-text" v-if="item.title" v-html="item.title"></p>
            </div>
            <div class="wrap-more">
              <span class="link-arrow">More</span>
            </div>
          </div>
        </div>
        <div class="show-more">
          <span class="btn btn-primary" v-if="(this.$store.state.counter + 10) < this.$store.state.idForSearchRequest.length"
                  @click="this.showMore()">Show more
          </span>
        </div>
      </div>
      <div class="output-message" v-if="this.$store.state.wholeDatabase.length === 0 && this.$store.state.fetchError === 0">
        <p>Unfortunately we found no matches regarding your search</p>
      </div>
      <div class="output-message" v-if="this.$store.state.fetchError > 0">
        <p>An Error occured - please try again later!</p>
      </div>
    </div>
    <div v-if="!this.$store.state.completedLoading" class="loading">
      <svg version="1.1" id="L4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
           viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
        <circle fill="#ff0000" stroke="none" cx="6" cy="50" r="6">
          <animate
              attributeName="opacity"
              dur="1s"
              values="0;1;0"
              repeatCount="indefinite"
              begin="0.1"/>
        </circle>
        <circle fill="#ff0000" stroke="none" cx="26" cy="50" r="6">
          <animate
              attributeName="opacity"
              dur="1s"
              values="0;1;0"
              repeatCount="indefinite"
              begin="0.2"/>
        </circle>
        <circle fill="#ff0000" stroke="none" cx="46" cy="50" r="6">
          <animate
              attributeName="opacity"
              dur="1s"
              values="0;1;0"
              repeatCount="indefinite"
              begin="0.3"/>
        </circle>
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    getModalId(id) {
      // Wird aufgerufen beim Klick auf einen Festival -> führt zur einzeige des Popups
      this.$store.commit('updateSelectedFestivalCard', id);
      this.$router.push({ path: this.$store.state.site, query: { show: id } });
    },
    showMore() {
      this.$store.commit('updateCounter', 10);
    },
    getNiceDate(unixTimestamp) {
      const timestamp = new Date(unixTimestamp * 1000);
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const year = timestamp.getFullYear();
      const month = months[timestamp.getMonth()];
      const date = timestamp.getDate();
      const output = `${date} ${month} ${year}`;
      return output;
    },
  },
  data() {
    return {
      sortCriteria: 'title,asc',
      options: { year: 'numeric', month: 'long', day: 'numeric' },
    };
  },
  watch: {
    // eslint-disable-next-line
    'sortCriteria': function () {
      this.$store.commit('updateSortCriteria', this.sortCriteria);
    },
    '$store.state.sortCriteria': async function () {
      this.sortCriteria = this.$store.state.sortCriteria;
    },
  },
};
</script>
<style lang="css">

.loading{
  padding: 3rem;
  width: 100%;
  display: flex;
  justify-content: center;
}
.loading svg{
  width: 150px;
}
.show-more{
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 3rem;
}

.output-message{
  padding: 3rem;
  text-align: center;
}

.wrap-more {
  display: flex;
  align-items: center;
  padding-bottom: .4rem;
  margin: 0 1rem;
  justify-content: end;
}

.wrap-more span {
  font-weight: bold;
  color: #3c3c3c;
}

.card-main-content{
  width: 100%;
}

.card-deck {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: .5rem 2rem 2rem 2rem;
  margin: 0;
}

.card-img {
  height: 100%;
  width: unset
}

.card-div {
  width: calc(100%/3 - 2rem);
  margin: 1rem;
  background: #fff;
  box-shadow: 5px 5px 15px #e3e3e3;
}

.card-div:hover {
  box-shadow: 5px 5px 15px #a4a4a4;
  cursor: pointer
}

.card-deck .card {
  background: transparent;
  border: none;
  margin: 0;
  height: 100%;
  border-left: solid 5px #3c3c3c;
  padding-top: 10px;
}

.card-img-wrapper {
  height: 238px;
  display: flex;
  justify-content: center;
  overflow: hidden
}

.error-picture{
  display: flex;
  height: 238px;
  align-items: center;
}
.error-picture p{
  text-align: center;
  font-size: small;
}

.card-deck .card-title-wrapper {
  display: flex;
  justify-content: center;
  align-items: end
}

.card-deck .card-title {
  color: #3c3c3c;
  padding: 2px 0 5px 0;
  font-size: 1rem;
  font-weight: 700;
  margin: 0;
  width: 100%;
  margin-bottom: 10px;
}

.card-deck .card-content{
  margin: 0 10px;
  width: calc(100% - 20px);
}
.card-deck .card-body {
  width: 100%;
  padding: 0;
}

.card-deck .card-text {
  overflow: hidden;
  font-size: .9rem;
  margin: 0 1rem;
  vertical-align: text-bottom;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.form-group {
  margin-bottom: 1rem
}

.year-wrapper {
  display: flex;
  flex-direction: row;
  align-content: space-between;
  align-items: center
}

input[type=checkbox]{
  display: none;
}
input[type=checkbox] + label {
  color: #3c3c3c;
}
.checkbox-container div{
  display: flex;
  align-items: center;
}

input[type=checkbox] + label::before {
  padding-right: 5px;
  font-family: 'icomoon' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\e90d";
}

[type="checkbox"]:checked+label::before {
  content: "\e90e";
}

.search-wrap {
  background: none;
  padding-top: 2rem;
  padding-right: 2rem;
}

.checkbox-container {
  transition: height 1s;
  border-bottom: 1px solid #fff;
  display: none;
  height: 0;
}

input[type=number] {
  border: none;
  background: transparent;
  width: 50%;
  color: #ffffff;
  font-size: medium;
  -moz-appearance: textfield;
}
input[type=number]:focus{
  outline: none;
}
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type=number]:invalid,
input[type=number]:out-of-range {
  border: 2px solid #ff6347;
}

.checkbox-container.extend-checkboxes {
  border-bottom: 1px solid #fff;
  display: unset;
  height: auto;
}

.search-wrap .form-control {
  background: none;
  color: #3c3c3c;
  border: none; /* site.css überschreiben */
  padding: 0;
  font-size: 1em;
  width: 100%;
  height: unset;
  margin-top: 2rem;
  border-bottom: 1px solid #3c3c3c;
}
.search-wrap .form-control:focus{
  box-shadow: none;
  border-bottom: 2px solid #3c3c3c;
  background: none;
  color: #3c3c3c;
}

.custom-select:focus{
  color: #495057;
  box-shadow: none;
  border: 1px solid #828282;
}

.sort-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.form-group .sort-wrapper span{
  font-weight: bold;
  width: auto;
}

.sort-wrapper .form-control{
  margin-left: 20px;
}
.sort-wrapper .form-control:focus{
  color: #495057;
}

.search-wrap .search-criteria {
  width: 100%;
  margin: 0;
  color: #3c3c3c;
  font-size: .85rem;
  line-height: .85rem;
  font-weight: bold;
}

.column {
  width: 47%;
}

#searchbar-buttons {
  display: flex;
  align-items: center;
  font-weight: bold;
  cursor: pointer;
}

#searchbar-buttons span{
  color: #3c3c3c;
}

.sorting {
  margin: 0 3rem;
  display: flex;
  justify-content: end;
  align-items: center;
  flex-wrap: wrap;
}

.sorting span {
  width: 100%;
  margin: 1rem 0 0.5rem 0;
  height: min-content;
}
.sorting .form-group {
  display: flex;
  justify-content: end;
  width: 100%;
  margin: 0
}
.extend-searchbar{
  padding-bottom: 10px;
  margin-top: 3rem;
  display: flex;
}
.extend-searchbar svg{
  width: 19px;
  stroke: #ffffff;
  stroke-width: 3px;
}

.extend-searchbar label.search-criteria {
  width: calc(100% - 19px);
  font-size: 1rem;
  font-weight: 700;
  line-height: 1rem;
}
.searchbar-footerline {
  margin: 3rem 0 2rem 0;
  display: flex;
  justify-content: flex-end;
}

.modal-container {
  width: 95%;
  margin: 0 2.5%
}
.modal-container .title{
  color: #3c3c3c;
  width: 100%;
  font-size: 1.5rem;
  padding-bottom: 10px;
  border-bottom: 5px solid #fff;
  margin-bottom: 20px;
}

.title p{
  width: 100%;
  display: flex;
  margin: 0;
}

.description {
  border-bottom: 5px solid #fff;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.modal-content {
  width: 100%;
  display: unset;
  background: transparent;
  border: none;
  flex-direction: unset
}

.modal-image {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: .5rem;
  height: 250px;
  width: 350px
}

.modal-backdrop {
  display: flex;
  background: hsla(0, 0%, 92.2%, .45);
  border-radius: 10px;
  border: 1px solid hsla(0, 0%, 100%, .18)
}

.modal {
  margin-top: 5rem;
  margin-left: 10%;
  margin-right: 10%;
  padding: 10px;
  width: 80%;
  height: 85% ;
  background: #dcdcdc;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  overflow-y: scroll
}

.modal-footer, .modal-header {
  padding: 15px;
  display: flex
}

.modal-header {
  position: relative;
  border-bottom: 1px solid #eee;
  color: #9a1d1d;
  justify-content: space-between
}

.modal-footer {
  border-top: 1px solid #eee;
  flex-direction: column
}

.modal-body {
  position: relative;
  padding: 20px 10px
}

.modal-fade-enter, .modal-fade-leave-to {
  opacity: 0
}

.modal-fade-enter-active, .modal-fade-leave-active {
  transition: opacity .5s ease
}

.wrap-modal {
  width: 100%;
  margin: 50%
}

.modal .wrap-image .card-img {
  width: 100%;
  /*height: 15rem*/
}

.wrap-image {
  padding-bottom: .4rem
}

.btn-close {
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  font-size: 20px;
  padding: 10px;
  cursor: pointer;
  font-weight: 700;
  color: #9a1d1d;
  background: transparent
}

.wrap-back-button {
  display: flex;
  align-items: center;
  color: #3c3c3c;
  cursor: pointer;
  justify-content: flex-end;
}

.wrap-back-button span{
  font-weight: bold;
}

.wrap-details {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  border-bottom: 5px solid #fff;
  padding-bottom: 10px;
  margin-bottom: 20px;
  justify-content: space-between;
}

.detail-value {
  width: calc(100% - clamp(10rem, 22vw, 15rem));
  margin: 0;
  padding: 0;
}

.wrap-details p {
  width: calc(100% - 2rem);
  margin: 0.3rem 0rem;
  display: flex;
  justify-content: space-between;
  font-size: large
}
.wrap-details.text p{
  margin: 1rem 0;
}

.strong {
  font-weight: 700;
  width: clamp(10rem,22vw,15rem);
}

.wrapper-fl-searchbar {
  display: flex;
  flex-wrap: wrap;
}

.searchbar {
  align-self: flex-start;
  width: calc(100% /3);
  height: min-content;
  top: 0;
}

.filmliste {
  width: calc(100% /3 * 2);
}

body, html {
  padding: 0;
  margin: 0;
}
@media (min-width: 0px) {
  .card-deck .card-div{
    width: calc(100% - 2rem);
  }
  .card-deck .card-main-content{
    width: 100%;
    max-width: unset;
  }
  .card-deck .card-body{
    flex-wrap: wrap;
  }
}
@media (min-width: 768px) {
  .card-deck .card-div{
    width: calc(100% - 2rem);
  }
  .card-deck .card-main-content{
    width: 100%;
    max-width: unset;
  }
  .card-deck .card-body{
    flex-wrap: wrap;
  }
}
@media (min-width: 992px) {
  .card-deck .card-div{
    width: calc(100% / 2- 2rem);
  }
  .card-deck .card-main-content{
    width: 100%;
    max-width: 253px;
  }
  .card-deck .card-body{
    flex-wrap: unset;
  }

  .sort-wrapper .form-control{
    width: 60%;
  }
}
@media (min-width: 1200px) {
  .card-deck .card-main-content{
    width: 100%;
    max-width: 313px;
  }

  .sort-wrapper .form-control{
    width: 50%;
  }
}
@media (max-width: 1200px){
  .wrap-details p {
    width: calc(100% - 2rem);
  }
  .modal{
    width: 75%;
    margin: 5rem 12.5% 0 12.5%;
  }
  .sorting .form-group, .sorting span{
    width: 100%;
    justify-content: start;
  }
}
@media (max-width: 767px) {
  .modal{
    width: 100%;
    margin: 5rem 0% 0 0%;
  }
  .searchbar{
    width: 100%;
  }
  .filmliste{
    width: 100%;
  }
  .sorting{
    margin: 1rem 0 0 0;
  }
  .card-deck{
    padding: 0;
  }
}

@media print{
  * {
    margin: 0 !important;
  }
  .wrap-back-button, .wrap-print-button, h1, h2, h3, h4, h5, .carousel, .topbar, #page-header, .breadcrumb-section, #page-footer, .card-group-element.card-group-element-align-left.card-group-element-columns-2{
    display: none !important;
  }
  .wrap-modal{
    margin: 0;
  }
  .modal-backdrop{
    display: block;
    position: static;
    height: unset;
    margin: 0;
  }
  .modal{
    position: static;
    top: 0;
    margin: 0;
    width: 100%;
    display: block;
    overflow-x: hidden;
    overflow-y: unset;
    height: 100%;
    margin-top: 0;
  }
  .filmliste, .searchbar{
    overflow: hidden !important;
    height: 0 !important;
  }
  #app{
    position: absolute;
  }
}
</style>
